import {Types} from "./types";

const initialState = {
    dataUserClient: {
        paging: {},
        rows: [],
    },
    dataUserClientCMS: {
        paging: {},
        rows: [],
    },
    dataUserClientById: {},
    dataThongKeUser: {},
    dataListUserCommissions: {},
    dataListTopRunner: {},
    dataListEvent: {},
    dataUrBox: {},
    dataHistoryChangeCoinById: {
        paging: {},
        rows: [],
    },
    dataReferral: {
        paging: {},
        rows: [],
    },
    dataUserReferralById: {
        paging: {},
        rows: [],
    },
    dataMilestoneReferral: {
        paging: {},
        rows: [],
    },
    dataUserMilestoneReferralById: {
        paging: {},
        rows: [],
    },
    dataListKYC: {
        paging: {},
        rows: [],
    },
    dataUserKYC: {
        paging: {},
        rows: [],
    },
    dataMaster: {
        paging: {},
        rows: [],
    },
    dataHistoryMaster: {
        paging: {},
        rows: [],
    },
    dataListMilestone: {
        paging: {},
        rows: [],
    },
    dataHistoryChangeCoin: {
        paging: {},
        rows: [],
    },
    dataInvestUser: {
        paging: {},
        rows: [],
    },
    dataRequestUpgrade: {
        paging: {},
        rows: [],
    },
    dataLockWithdraw: {
        paging: {},
        rows: [],
    },
    dataPnl: {
        paging: {},
        rows: [],
    },
    historyPnl: {
        paging: {},
        rows: [],
    },
};
const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_USER_CLIENT:
            return {
                ...newState,
                dataUserClient: action.payload,
            };
        case Types.SAVE_LIST_USER_CLIENT_CMS:
            return {
                ...newState,
                dataUserClientCMS: action.payload,
            };
        case Types.SAVE_INVEST_BY_USER:
            return {
                ...newState,
                dataInvestUser: action.payload,
            };
        case Types.SAVE_LIST_USER_COMMISSION:
            return {
                ...newState,
                dataListUserCommissions: action.payload,
            };
        case Types.TOP_RUNNER:
            return {
                ...newState,
                dataListTopRunner: action.payload,
            };
        case Types.EVENT:
            return {
                ...newState,
                dataListEvent: action.payload,
            }
        case Types.UR_BOX:
            return {
                ...newState,
                dataUrBox: action.payload,
            };
        case Types.SAVE_LIST_CONFIG_MILESTONE:
            return {
                ...newState,
                dataListMilestone: action.payload,
            };
        case Types.SAVE_HISTORY_MASTER:
            return {
                ...newState,
                dataHistoryMaster: action.payload,
            };
        case Types.SAVE_LIST_MASTER:
            return {
                ...newState,
                dataMaster: action.payload,
            };
        case Types.SAVE_USER_CLIENT_BY_ID:
            return {
                ...newState,
                dataUserClientById: action.payload,
            };
        case Types.SAVE_STATISTIC_USER:
            return {
                ...newState,
                dataThongKeUser: action.payload,
            };
        case Types.SAVE_HISTORY_CHANGE_COIN_BY_ID:
            return {
                ...newState,
                dataHistoryChangeCoinById: action.payload,
            };
        case Types.SAVE_LIST_REFERRAL:
            return {
                ...newState,
                dataReferral: action.payload,
            };
        case Types.SAVE_USER_REFERRAL_BY_ID:
            return {
                ...newState,
                dataUserReferralById: action.payload,
            };
        case Types.SAVE_LIST_MILESTONE_REFERRAL:
            return {
                ...newState,
                dataMilestoneReferral: action.payload,
            };
        case Types.SAVE_USER_MILESTONE_REFERRAL_BY_ID:
            return {
                ...newState,
                dataUserMilestoneReferralById: action.payload,
            };
        case Types.SAVE_LIST_USER_KYC:
            return {
                ...newState,
                dataListKYC: action.payload,
            };
        case Types.SAVE_USER_KYC:
            return {
                ...newState,
                dataUserKYC: action.payload,
            };
        case Types.SAVE_HISTORY_CHANGE_COIN:
            return {
                ...newState,
                dataHistoryChangeCoin: action.payload,
            };
        case Types.SAVE_LIST_REQUEST_UPGRADE_USER:
            return {
                ...newState,
                dataRequestUpgrade: action.payload,
            };
        case Types.SAVE_LIST_LOCK_WITHDRAW_BY_LOGIN:
            return {
                ...newState,
                dataLockWithdraw: action.payload,
            };
        case Types.SAVE_LIST_PNL: {
            return {
                ...newState,
                dataPnl: action.payload,
            };
        }
        case Types.SAVE_LIST_HISTORY_PNL: {
            return {
                ...newState,
                historyPnl: action.payload,
            };
        }
        default:
            return {...newState};
    }
};
export default reducer;
